<template>

    <!-- footer-area -->
    <footer>
        <div class="footer__area-two">
            
            <div class="footer__top-two">
                <div class="container">
                    <div class="row">
                        <div class="col-xl-3 col-lg-5 col-md-6">
                            <div class="footer-widget">
                                <div class="footer__content-two">
                                    <div class="fw-logo mb-10">
                                        <router-link to="/">
                                            <img src="/assets/img/distransnaker.png" alt="Logo" style="width: 250px; height: auto;"/>
                                        </router-link>
                                    </div>
                                    <p>Website Dinas Transmigrasi dan Tenaga Kerja Kabupaten Konawe Selatan</p>
                                    <div class="footer__social-two">
                                        <ul class="list-wrap">
                                            <li>
                                                <a href="javascript:void(0)"><i class="fab fa-facebook-f"></i></a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)"><i class="fab fa-instagram"></i></a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)"><i class="fab fa-youtube"></i></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-sm-6">
                            <div class="footer-widget">
                                <h4 class="fw-title">Kontak</h4>
                                <div class="footer-info-list footer-info-two">
                                        <ul class="list-wrap">
                                            <li>
                                                <div class="icon">
                                                    <i class="flaticon-phone-call"></i>
                                                </div>
                                                <div class="content">
                                                    <a href="#">0821-9327-8680</a>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="icon">
                                                    <i class="flaticon-envelope"></i>
                                                </div>
                                                <div class="content">
                                                    <a href="#">distransnaker@konaweselatankab.go.id</a>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="icon">
                                                    <i class="flaticon-pin"></i>
                                                </div>
                                                <div class="content">
                                                    <p>Andoolo, Kec. Andoolo, Kabupaten Konawe Selatan, Sulawesi Tenggara 93884</p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-4 col-sm-6">
                            <div class="footer-widget">
                                <h4 class="fw-title">Information</h4>
                                <div class="footer-link-list">
                                    <ul class="list-wrap">
                                        <li><router-link to="/BeritaOPD">Berita</router-link></li>
                                        <li><router-link to="/TugasPokok">Tugas Pokok</router-link></li>
                                        <li><router-link to="/TujuanSasaran">Tujuan & Sasaran</router-link></li>
                                        <li><router-link to="/Kontak">Kontak</router-link></li>
                                        <li>
                                            <a href="https://konaweselatankab.go.id/agenda_pengumuman/pengumuman/list" target="_blank" rel="noopener noreferrer">
                                                Pengumuman
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>



                        <div class="col-xl-3 col-lg-4 col-md-6">
                            <div class="footer-widget">
                                <h4 class="fw-title">Foto Kegiatan</h4>
                                <div class="footer-instagram">
                                    <ul class="list-wrap foto-grid">
                                        <li v-for="data in list_foto.slice(0, 4)" :key="data.id" class="foto-item">
                                            <router-link to="/FotoOPD">
                                            <img :src="file_path + data.file" alt="foto kegiatan" />
                                            </router-link>
                                        </li>
                                        </ul>
                                </div>
                            </div>
                            </div>
                    </div>
                </div>
            </div>
            <div class="footer__bottom-two">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="copyright-text-two">
                                <p>Copyright © <a href="javascript:void(0);">2025 Kabupaten Konawe Selatan</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    <!-- footer-area-end -->

</template>


<script>

import { useStore } from 'vuex'
const URL_APP = 'https://server-web.konaweselatankab.go.id/';

const ADD_URL_FOTO = URL_APP + "api/v1/publish_dinsos_foto/home/";

export default {
data() {
const store = useStore()
const baseURL = store.state.URL_APP

return {
  unit_kerja: store.state.UNIT_KERJA,
  file_path: baseURL + 'uploads/',
  list_foto: [],
 
}
},
mounted() {
 // Inisialisasi Swiper
    new window.Swiper('.brand-active', {
        slidesPerView: 5,
        spaceBetween: 30,
        loop: true,
        autoplay: {
        delay: 2000,
        disableOnInteraction: false,
        },
        breakpoints: {
        320: { slidesPerView: 2 },
        768: { slidesPerView: 3 },
        1024: { slidesPerView: 5 }
        }
    })

    this.getFoto();


},
methods: {

truncateText(text, limit = 50) {
if (!text) return '';
return text.length > limit ? text.substring(0, limit) + '...' : text;
},

cek_active(index) {
  return index === 0 ? 'active' : '';
},

getFoto: function() {
    fetch(ADD_URL_FOTO, {
        method: "get",
        headers: {
            "content-type": "application/json",
        },
    })
        .then(res => res.json())
        .then(res_data => { 
            // console.log('🔍 list_foto:', res_data);
            this.list_foto = res_data
            
    });
},



},
}
</script>

<style scoped>
.hero {
padding: 60px 0;
background-color: #f8f9fa;
text-align: center;
}
</style>
